// import SchedulingScreen from "./SchedulingScreen/SchedulingScreen";
import { Box, Typography } from "@mui/material";
import styles from "./HallSchedule.module.scss";
import CustomDatePicker from "../../common/DatePicker/DatePicker";
import { useState } from "react";
import dayjs from "dayjs";
import { CustomRequiredInputLabel } from "../../common/StyledComponents/StyledFields";
import { useFormik } from "formik";
import CustomSelectField from "../../common/CustomSelectField/CustomSelectField";
import { useAppSelector } from "../../../app/hook";
import CustomizedSwitch from "../../common/CustomToggle/CustomToggle";
import { Toaster } from "react-hot-toast";
import { allBrowserDateCompatability, displayDateFormat } from "../../../infrastructure/backendService";
import HallSchedulingScreen from "./HallSchedulingScreen";

const hallBookingDetailsStyles = {
  hallBookingFieldContainer: {
    maxWidth: { xs: "100%", sm: "320px" },
    width: "320px",
    pr: { xs: "0px", sm: "15px" },
    mb: "10px",
  },
};

interface HallScheduleProps {
  setShowHallScheduleScreen?: (show: boolean) => void;
}

const HallSchedule = (props: HallScheduleProps) => {
  const { hallList, hallBookingDetails } = useAppSelector(
    (state) => state.hallBooking
  );
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const initialData = {
    ...hallBookingDetails,
    date: hallBookingDetails?.date,
    time: hallBookingDetails?.time,
    hallId: hallBookingDetails?.hallId,
    daily: false,
  };
  const formik = useFormik({
    initialValues: initialData,
    onSubmit: (values) => {},
    enableReinitialize: true,
  });

  const getHallName = (hallId: number | null) => {
    const hallDetails = hallList.find((item: any) => item.id === hallId);

    return hallDetails?.name;
  };

  const handleDateChange = (field: string, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    const date = formattedDate.isValid()
      ? formattedDate.format("MM-DD-YYYY")
      : "";
    formik.setFieldValue(field, date);
  };

  const handleFieldChange = (field: string, value: any) => {
    formik.setFieldValue(field, value);
    if (field === "hallId") {
      formik.setFieldValue("hallName", getHallName(value));
    }
  };

  const renderHallRequestDetails = () => {
    return (
      <Box className={styles.hallBookingDetailsTableContainer}>
        <table className={styles.hallBookingDetailsTable}>
          <thead>
            <tr>
              <th>Hall ID</th>
              <th>Hall Name</th>
              <th>Devotee ID</th>
              <th>Description</th>
              <th>Devotee Requests Start Date</th>
              <th>Hall Time Required</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{hallBookingDetails?.hallId}</td>
              <td>{hallBookingDetails?.hallName}</td>
              <td>{hallBookingDetails?.devoteeID}</td>
              <td>
                {hallBookingDetails?.halldesc
                  ? hallBookingDetails?.halldesc
                  : "-"}
              </td>
              <td>
                {displayDateFormat(new Date(allBrowserDateCompatability(hallBookingDetails?.date)))}{" "}
                {hallBookingDetails?.time}
              </td>
              <td>
                {hallBookingDetails?.hallHours * 60 +
                  hallBookingDetails?.hallmins}{" "}
                minutes
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
    );
  };

  const renderHallDetails = () => {
    return (
      <Box className={styles.hall_details_main_container}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <Box sx={hallBookingDetailsStyles.hallBookingFieldContainer}>
            {CustomRequiredInputLabel("Date", false)}
            <CustomDatePicker
              isDatePickerOpen={isDatePickerOpen}
              setDatePickerOpen={setDatePickerOpen}
              date={formik.values.date}
              handleDateChange={handleDateChange}
              errorMessage={formik.errors.date}
            />
          </Box>
          {!formik.values.daily && (
            <>
              <Box sx={hallBookingDetailsStyles.hallBookingFieldContainer}>
                {CustomRequiredInputLabel("Select Hall", false)}
                <CustomSelectField
                  handleDropdownChange={handleFieldChange}
                  errorMessage={formik.errors.hallId}
                  dropDownList={hallList}
                  value={formik.values.hallId}
                  fieldName="hallId"
                  placeholder={"Select hall"}
                  optionLabel={"name"}
                  optionValue={"id"}
                />
              </Box>
            </>
          )}
          <Box
            sx={{
              ...hallBookingDetailsStyles.hallBookingFieldContainer,
              pt: "17px",
              display: "flex",
              alignItems: "center",
              height: "54px",
            }}
          >
            <Typography className={styles.toggle_hall_text} mr="13px">
              Weekly
            </Typography>
            <CustomizedSwitch
              fieldName={"daily"}
              isChecked={formik.values.daily}
              handleChange={handleFieldChange}
            />
            <Typography className={styles.toggle_hall_text} ml="13px">
              Daily
            </Typography>
          </Box>
        </Box>
        {renderHallRequestDetails()}
      </Box>
    );
  };

  return (
    <>
      <Toaster />
      {renderHallDetails()}
      <HallSchedulingScreen
        formik={formik}
        setShowHallScheduleScreen={props?.setShowHallScheduleScreen}
      />
    </>
  );
};

export default HallSchedule;
